"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        function getCollectionName(modelName) {
            if (modelName) {
                var collectionNameTerminator = modelName.lastIndexOf("_ds");
                if (collectionNameTerminator !== -1) {
                    return modelName.substr(0, collectionNameTerminator);
                }
            }
            return modelName;
        }
        serverForm.getCollectionName = getCollectionName;
        function isModelCollection(obj) {
            return obj && obj.items ? true : false;
        }
        serverForm.isModelCollection = isModelCollection;
        var ModelCollection = /** @class */ (function () {
            function ModelCollection(parent, collectionName) {
                var _this = this;
                this.parent = parent;
                this.itemsChanged = function () {
                    if (!_this._itemsChangedHost) {
                        _this._itemsChangedHost = new $dyn.eventHost();
                    }
                    return _this._itemsChangedHost;
                };
                this.name = collectionName;
                this.UseReactGrid = parent && parent.getValue("UseReactGrid");
                this.selectedIndex = $dyn.observable(-1);
                this.items = this.UseReactGrid ? $dyn.observableArray([]) : $dyn.observable([]);
                this.hasNextPage = $dyn.observable(false);
                this.pageIndex = $dyn.observable(0);
                this.CacheSize = $dyn.observable(0);
                this.FetchedDataStartPosition = $dyn.observable(0);
                this.DataAbove = $dyn.observable(false);
                this.DataBelow = $dyn.observable(false);
                this.valuesIfEmpty = $dyn.observable();
                this.activeRecordModel = $dyn.observable();
                this.activeRecord_mastertrackingid = $dyn.observable("");
                this.internalActiveMasterTrackingId = $dyn.observable("");
                this.activeDataRowTrackingId = $dyn.observable("");
                this.clientPageSize = $dyn.observable(25);
                this.markedIndexes = $dyn.observable([]);
                this.masterDataSourceName = $dyn.observable();
                this.IsDirty = false;
                this.IsCrossCompany = false;
                this.onClear = new $dyn.eventHost();
                this.clientCreatedTrackingId = 0;
                this.numberOfClientRows = 0;
                this.clientGridSizeLimited = false;
                // If the React grid is in use, the model collection needs to ensure the control library is loaded before utilizing
                // concepts like BigNumber. Thus the logic below is part of the footer count mechanism that queues up totals for
                // models that are deserialized before the control library is loaded, and counts them up after the required scripts
                // are ready.
                if (this.UseReactGrid) {
                    this.totals = {};
                    this.totalsVersion = 0;
                    this.markedCount = $dyn.observable(0);
                    this._pendingFieldTotals = {};
                    $dyn.observe($dyn.util.controlLibraryResourcesLoaded, function (newValue) {
                        if (newValue) {
                            // tslint:disable-next-line:forin
                            for (var fieldName in _this._pendingFieldTotals) {
                                var values = _this._pendingFieldTotals[fieldName];
                                while (values.length) {
                                    (_this.totals[fieldName] ||
                                        (_this.totals[fieldName] = new ControlLibrary.BigNumber({
                                            initialValue: 0,
                                        }))).add(values.pop());
                                }
                            }
                            _this.totalsVersion++;
                            return false;
                        }
                    });
                    $dyn.observe(this.internalActiveMasterTrackingId, function (newValue) {
                        if (newValue && !newValue.startsWith($dyn.reactGrid.GROUP_HEADER_PREFIX)) {
                            _this.activeDataRowTrackingId(newValue);
                        }
                    });
                }
            }
            ModelCollection.prototype.setMarked = function (index, value) {
                var _this = this;
                if (this.markedIndexes()[index] !== value) {
                    if (!this._markedChanging) {
                        $dyn.async(function () {
                            // Ensure that this is detected as a change.
                            _this.markedIndexes(_this.markedIndexes().slice(0));
                            _this._markedChanging = false;
                        }, 0, "Marked indexes changed");
                        this._markedChanging = true;
                    }
                    this.markedIndexes()[index] = value;
                }
            };
            ModelCollection.prototype.addChange = function (change) {
                // get the range of rows that changed.
                if (change.collectionIndex !== undefined) {
                    serverForm.UpdateModelManager.pushModelCollectionChange(this.id);
                }
            };
            ModelCollection.prototype.clearModels = function (formId) {
                var firstClientRowIndex = -1;
                for (var i = 0; i < $dyn.length(this.items); i++) {
                    var model = this.items()[i];
                    if (model && model.masterTrackingId && parseInt(model.masterTrackingId, 10) < 0) {
                        firstClientRowIndex = i;
                        break;
                    }
                    var modelId = this.name + "_" + model.masterTrackingId;
                    var formModels = serverForm.ModelManager.models[formId];
                    if (!serverForm.isModel(formModels) && formModels[modelId]) {
                        delete formModels[modelId];
                    }
                }
                if ($dyn.isObservableArray(this.items)) {
                    if (firstClientRowIndex > 0) {
                        this.items.splice(0, firstClientRowIndex);
                    }
                    else {
                        this.items.clear();
                    }
                }
                $dyn.log.reactList && $dyn.log.reactList("Cache cleared for " + this.name + " on form " + formId);
                this.activeRecord_mastertrackingid("");
                if ($dyn.value(this.internalActiveMasterTrackingId) && parseInt($dyn.value(this.internalActiveMasterTrackingId), 10) > 0) {
                    this.internalActiveMasterTrackingId("");
                }
                // Reset counts
                this.totals = {};
                this.totalsVersion = 0;
                $dyn.setValue(this, "markedCount", 0);
                this.onClear.raise();
            };
            ModelCollection.prototype.getRelated = function (propertyName, collectionIndex) {
                if (this.parent && this.parent.getRelated) {
                    return this.parent.getRelated(propertyName, collectionIndex);
                }
            };
            ModelCollection.prototype.getRelatedCollection = function (propertyName) {
                if (this.parent && this.parent.getRelatedCollection) {
                    return this.parent.getRelatedCollection(propertyName);
                }
            };
            ModelCollection.prototype.mergeModelUpdates = function (data, updateModelInteractions) {
                if (!data) {
                    return;
                }
                // TODO: Ideally these are merged on server before being sent down and this isn't necessary
                if (this.UseReactGrid) {
                    if (data.SpliceOperations && data.SpliceOperations.length) {
                        for (var i = 0, len = data.SpliceOperations.length; i < len; i++) {
                            var spliceOperation = data.SpliceOperations[i];
                            var insertCount = spliceOperation.Insert ? spliceOperation.Insert.length : 0;
                            for (var j = 0; j < insertCount; j++) {
                                if (updateModelInteractions[spliceOperation.Insert[j].Id]) {
                                    spliceOperation.Insert[j].Item = updateModelInteractions[spliceOperation.Insert[j].Id].Descriptor;
                                    delete updateModelInteractions[spliceOperation.Insert[j].Id];
                                }
                            }
                        }
                    }
                    else if (data.Items) {
                        for (var i = 0, len = data.Items.length; i < len; i++) {
                            if (updateModelInteractions[data.Items[i].Id]) {
                                data.Items[i].Item = updateModelInteractions[data.Items[i].Id].Descriptor;
                                delete updateModelInteractions[data.Items[i].Id];
                            }
                        }
                    }
                }
            };
            ModelCollection.prototype._addFieldTotal = function (fieldName, value) {
                if ($dyn.value($dyn.util.controlLibraryResourcesLoaded)) {
                    (this.totals[fieldName] ||
                        (this.totals[fieldName] = new window.ControlLibrary.BigNumber({
                            initialValue: 0,
                        }))).add(value);
                    this.totalsVersion++;
                }
                else {
                    (this._pendingFieldTotals[fieldName] || (this._pendingFieldTotals[fieldName] = [])).push(value);
                }
            };
            ModelCollection.prototype.deserialize = function (data, formId) {
                var _this = this;
                if (!data) {
                    return;
                }
                if ($dyn.debug.general) {
                    if (!this.dynPrevDescriptors) {
                        this.dynPrevDescriptors = [];
                    }
                    this.dynPrevDescriptors.push(data);
                }
                this.id = data.Id;
                serverForm.ModelManager.trackModelCollection(this, formId);
                if (data.Name) {
                    this.name = getCollectionName(data.Name);
                }
                if (data.MasterDataSourceName !== undefined && data.MasterDataSourceName !== null) {
                    this.masterDataSourceName(data.MasterDataSourceName);
                }
                if (data.ValuesIfEmpty) {
                    if (this.UseReactGrid) {
                        if (data.ValuesIfEmpty.Item && data.ValuesIfEmpty.Item.Properties) {
                            data.ValuesIfEmpty.Item.Properties.MasterTrackingId = "valuesIfEmpty";
                            this.valuesIfEmpty(this.deserializeModel(data.ValuesIfEmpty, -1, formId));
                        }
                    }
                    else {
                        this.valuesIfEmpty(this.deserializeModel(data.ValuesIfEmpty, 0, formId));
                    }
                }
                if (data.FetchedDataStartPosition !== undefined && data.FetchedDataStartPosition !== null) {
                    this.FetchedDataStartPosition(data.FetchedDataStartPosition);
                }
                // cache the array of fields with totals
                if (this.UseReactGrid && data.FieldsWithTotals && (this.rawFieldsWithTotals !== data.FieldsWithTotals)) {
                    try {
                        this.fieldsWithTotals = JSON.parse(data.FieldsWithTotals);
                        this.rawFieldsWithTotals = data.FieldsWithTotals;
                    }
                    catch (e) { } // tslint:disable-line:no-empty
                }
                if (data.SpliceOperations) {
                    if (data.SpliceOperations.length > 0) {
                        this._pendingCollectionChange = true;
                        if (this.UseReactGrid && this.name !== "ClientMessageLog") {
                            var groupingFeatureEnabled_1 = $dyn.reactGrid.GroupingManager.flightEnabled();
                            var masterDsName_1 = getCollectionName($dyn.value(this.masterDataSourceName));
                            var isMasterDS_1 = (masterDsName_1 === this.name);
                            var cacheCleared = false;
                            var _loop_1 = function (i, len) {
                                var e_1, _a, _b, _c;
                                var spliceOperation = data.SpliceOperations[i];
                                if (spliceOperation.ClearCache) {
                                    this_1.clearModels(formId);
                                    cacheCleared = true;
                                }
                                else if (spliceOperation.MarkAll !== undefined) {
                                    if (!this_1.clientMarking) {
                                        // Subsequent UpdateModelInteraction interactions will correct the mark state for any in-page records (in the mark all -> single record case)
                                        var modelArray = $dyn.value(this_1.items);
                                        try {
                                            for (var modelArray_1 = (e_1 = void 0, __values(modelArray)), modelArray_1_1 = modelArray_1.next(); !modelArray_1_1.done; modelArray_1_1 = modelArray_1.next()) {
                                                var model = modelArray_1_1.value;
                                                model.isMarked = spliceOperation.MarkAll;
                                            }
                                        }
                                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                        finally {
                                            try {
                                                if (modelArray_1_1 && !modelArray_1_1.done && (_a = modelArray_1.return)) _a.call(modelArray_1);
                                            }
                                            finally { if (e_1) throw e_1.error; }
                                        }
                                    }
                                }
                                else {
                                    var insertCount = spliceOperation.Insert ? spliceOperation.Insert.length : 0;
                                    if (insertCount > 0) {
                                        // default is to insert at the beginning
                                        var modelCollectionOffset = 0;
                                        var insertingAtEnd = false;
                                        var beforeModel = void 0;
                                        var firstInsertItem = spliceOperation.Insert[0];
                                        if (firstInsertItem.Item.Properties.previous_MasterTrackingId) {
                                            var beforeModelId = this_1.name + "_" + firstInsertItem.Item.Properties.previous_MasterTrackingId;
                                            beforeModel = serverForm.ModelManager.getModel(beforeModelId, formId);
                                        }
                                        var afterModel = void 0;
                                        var lastInsertItem = spliceOperation.Insert[spliceOperation.Insert.length - 1];
                                        if (lastInsertItem.Item.Properties.next_MasterTrackingId) {
                                            var afterModelId = this_1.name + "_" + lastInsertItem.Item.Properties.next_MasterTrackingId;
                                            afterModel = serverForm.ModelManager.getModel(afterModelId, formId);
                                        }
                                        if (beforeModel) {
                                            // If first item is connected to cache
                                            var beforeItemIndex = $dyn.value(beforeModel.collectionIndex);
                                            modelCollectionOffset = beforeItemIndex + 1;
                                            if (!afterModel) {
                                                // last item is not connected, so we are adding at the end
                                                insertingAtEnd = true;
                                            }
                                        }
                                        else if (afterModel) {
                                            // If last item is connected to cache (and first item is not), then we are adding at the beginning, which is the default
                                        }
                                        else {
                                            // Maybe we got the same first or last record, so the first's previous or last's next wouldn't exist in our cache
                                            // so check for if the first or last record exists in our cache, which would make this not a sparse cache scenario
                                            var firstInsertItemModelId = this_1.name + "_" + firstInsertItem.Item.Properties.MasterTrackingId;
                                            var firstInsertItemModel = serverForm.ModelManager.getModel(firstInsertItemModelId, formId);
                                            var lastInsertItemModelId = this_1.name + "_" + lastInsertItem.Item.Properties.MasterTrackingId;
                                            var lastInsertItemModel = serverForm.ModelManager.getModel(lastInsertItemModelId, formId);
                                            if (firstInsertItemModel) {
                                                modelCollectionOffset = $dyn.value(firstInsertItemModel.collectionIndex);
                                                if (!lastInsertItemModel) {
                                                    insertingAtEnd = true;
                                                }
                                            }
                                            else if (lastInsertItemModel) {
                                                // if last item is in the cache and first isn't, then we are adding at the beginning
                                            }
                                            else if (!cacheCleared) {
                                                // no overlap and cache hasnt been cleared yet, clear cache to prevent sparse cache
                                                this_1.clearModels(formId);
                                                cacheCleared = true;
                                            }
                                        }
                                        if (!insertingAtEnd) {
                                            // If scroll direction is none, we need to set this flag on the ModelManager
                                            // so after all the updateModelCollection interactions have run, we set the load direction to up
                                            serverForm.ModelManager.insertedRecordsAbove = true;
                                            serverForm.ModelManager.activeRootId = formId;
                                        }
                                        var actuallyInserted = false;
                                        var contiguousRecords = [];
                                        for (var j = 0; j < insertCount; j++) {
                                            var insertItem = spliceOperation.Insert[j];
                                            if (insertItem.Item.Properties.MasterTrackingId) {
                                                var modelId = this_1.name + "_" + insertItem.Item.Properties.MasterTrackingId;
                                                var model = serverForm.ModelManager.getModel(modelId, formId);
                                                if (model) {
                                                    // Treat this as update to existing record
                                                    this_1.deserializeModel(insertItem, j + modelCollectionOffset, formId);
                                                    // Insert current batch of records
                                                    if (contiguousRecords.length > 0 && $dyn.isObservableArray(this_1.items)) {
                                                        (_b = this_1.items).splice.apply(_b, __spread([contiguousRecords[0].collectionIndex, 0], contiguousRecords));
                                                        actuallyInserted = true;
                                                        contiguousRecords = [];
                                                    }
                                                }
                                                else {
                                                    contiguousRecords.push(this_1.deserializeModel(insertItem, j + modelCollectionOffset, formId));
                                                }
                                            }
                                            else {
                                                $dyn.log.reactList && $dyn.log.reactList("splice insert with no master tracking id: " + insertItem.Id);
                                            }
                                        }
                                        if (contiguousRecords.length > 0 && $dyn.isObservableArray(this_1.items)) {
                                            (_c = this_1.items).splice.apply(_c, __spread([contiguousRecords[0].collectionIndex, 0], contiguousRecords));
                                            actuallyInserted = true;
                                            if (insertingAtEnd) {
                                                var lastRecordAddedCollectionIndex = contiguousRecords[contiguousRecords.length - 1].collectionIndex;
                                                if (lastRecordAddedCollectionIndex < $dyn.length(this_1.items) - 1) {
                                                    // if the last record I inserted isnt the last record in the collection, need to update collection indices
                                                    // this can happen if we havent deleted the last model yet, or there are client created models not sunk yet
                                                    for (var j = lastRecordAddedCollectionIndex + 1; j < $dyn.length(this_1.items); j++) {
                                                        $dyn.value(this_1.items)[j].collectionIndex = j;
                                                    }
                                                }
                                                if (groupingFeatureEnabled_1 && isMasterDS_1) {
                                                    // update grouping
                                                    var lastGroupTrackingId_1 = "";
                                                    var previousCollectionIndex = contiguousRecords[0].collectionIndex - 1;
                                                    if (previousCollectionIndex >= 0 && formId && masterDsName_1) {
                                                        var previousLastItem = this_1.items()[previousCollectionIndex];
                                                        lastGroupTrackingId_1 = previousLastItem.getValue($dyn.reactGrid.PARENT_GROUP_KEY);
                                                    }
                                                    // Need to wait for all related ds to add their rows as well since the grouping might be on the related ds
                                                    var contiguousRecordsCopy_1 = contiguousRecords.slice();
                                                    this_1.addGroupingAction(function () {
                                                        $dyn.reactGrid.GroupingManager.addNewRowsToGroupingManger(formId, masterDsName_1, contiguousRecordsCopy_1, lastGroupTrackingId_1);
                                                    });
                                                }
                                            }
                                            contiguousRecords = [];
                                        }
                                        if (actuallyInserted && !insertingAtEnd) {
                                            var updatedItemsLength = $dyn.length(this_1.items);
                                            for (var j = insertCount + modelCollectionOffset; j < updatedItemsLength; j++) {
                                                $dyn.value(this_1.items)[j].collectionIndex = j;
                                            }
                                            if (groupingFeatureEnabled_1 && isMasterDS_1 && formId && masterDsName_1) {
                                                // if inserting before, then just redo grouping because we have to update start/end index of all groups,
                                                // as well as update rowIndex of all groups and models
                                                // Need to wait for all related ds to add their rows as well since the grouping might be on the related ds
                                                this_1.addGroupingAction(function () {
                                                    $dyn.reactGrid.GroupingManager.updateHeadersAndRerender(formId, masterDsName_1);
                                                });
                                            }
                                        }
                                    }
                                    else if (!cacheCleared && spliceOperation.Delete > 0 && spliceOperation.MasterTrackingIndex) {
                                        // TODO: Deletes should only be sent down when deleting a model (not change row or load data)
                                        var modelId = this_1.name + "_" + spliceOperation.MasterTrackingIndex;
                                        var model = serverForm.ModelManager.getModel(modelId, formId);
                                        if (model) {
                                            var deleteIndex = model.collectionIndex;
                                            if (model.isSelected) {
                                                model.isSelected = false;
                                            }
                                            // This type of delete is only for the react grid which is always an observable array
                                            if ($dyn.isObservableArray(this_1.items)) {
                                                var deletedItems = this_1.items.splice(deleteIndex, spliceOperation.Delete);
                                                for (var j = deleteIndex; j < $dyn.length(this_1.items); j++) {
                                                    $dyn.value(this_1.items)[j].collectionIndex = j;
                                                }
                                                if (deletedItems && deletedItems.length) {
                                                    // Delete is for contiguous records so our rows in the UI would also be contiguous
                                                    // so we only need where to start and how many to delete for splice
                                                    var firstRowIndexToDelete_1 = -1;
                                                    var numberOfRowsToDelete_1 = 0;
                                                    deletedItems.forEach(function (deletedItem) {
                                                        var groupTrackingId = "";
                                                        if (formId && masterDsName_1 && groupingFeatureEnabled_1) {
                                                            groupTrackingId = deletedItem.getValue($dyn.reactGrid.PARENT_GROUP_KEY);
                                                        }
                                                        if (_this.fieldsWithTotals && _this.fieldsWithTotals.length) {
                                                            _this.fieldsWithTotals.forEach(function (fieldName) {
                                                                var value = deletedItem.getValue(fieldName);
                                                                if (value !== undefined && value !== null && value !== "" && value !== 0) {
                                                                    value *= -1;
                                                                    _this._addFieldTotal(fieldName, value);
                                                                    if (groupTrackingId) {
                                                                        $dyn.reactGrid.GroupingManager.addFieldTotalForHierarchy(formId, masterDsName_1, groupTrackingId, _this.name, fieldName, value);
                                                                    }
                                                                }
                                                                if (deletedItem.isMarked) {
                                                                    $dyn.setValue(_this, "markedCount", $dyn.value(_this.markedCount) - 1);
                                                                    if (groupTrackingId && isMasterDS_1) {
                                                                        $dyn.reactGrid.GroupingManager.adjustMarkedCountForHierarchy(formId, masterDsName_1, groupTrackingId, -1);
                                                                    }
                                                                }
                                                            });
                                                        }
                                                        // remove from group
                                                        if (isMasterDS_1 && groupingFeatureEnabled_1) {
                                                            if (groupTrackingId) {
                                                                var deletedGroups = $dyn.reactGrid.GroupingManager.removeFromGroup(formId, masterDsName_1, groupTrackingId);
                                                                if (deletedGroups && deletedGroups.firstIndex >= 0 && deletedGroups.deleteCount > 0) {
                                                                    if (firstRowIndexToDelete_1 === -1 || deletedGroups.firstIndex < firstRowIndexToDelete_1) {
                                                                        firstRowIndexToDelete_1 = deletedGroups.firstIndex;
                                                                    }
                                                                    numberOfRowsToDelete_1 += deletedGroups.deleteCount;
                                                                }
                                                            }
                                                            if (deletedItem.rowIndex !== -1) {
                                                                if (firstRowIndexToDelete_1 === -1 || deletedItem.rowIndex < firstRowIndexToDelete_1) {
                                                                    firstRowIndexToDelete_1 = deletedItem.rowIndex;
                                                                }
                                                                numberOfRowsToDelete_1++;
                                                            }
                                                        }
                                                        var deletedModelId = _this.name + "_" + deletedItem.masterTrackingId;
                                                        serverForm.ModelManager.deleteModel(deletedModelId, formId);
                                                    });
                                                    if (groupingFeatureEnabled_1 && isMasterDS_1 && firstRowIndexToDelete_1 >= 0 && numberOfRowsToDelete_1 > 0) {
                                                        $dyn.reactGrid.GroupingManager.removeRowsFromGroupingManager(formId, masterDsName_1, firstRowIndexToDelete_1, numberOfRowsToDelete_1);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            };
                            var this_1 = this;
                            for (var i = 0, len = data.SpliceOperations.length; i < len; i++) {
                                _loop_1(i, len);
                            }
                        }
                        else {
                            // Make a copy of the current items array
                            // TODO: This line should eventually be removed, however there are some issues with observables not detecting the change
                            //       even if the "items" observable is updated with the forceUpdate flag set to true.
                            //       So a copy of the array must be used so that the observable detects that the value has changed
                            var currentItems = $dyn.value(this.items).slice(0);
                            for (var i = 0, len = data.SpliceOperations.length; i < len; i++) {
                                var spliceOperation = data.SpliceOperations[i];
                                if (spliceOperation.MasterTrackingIndex) {
                                    // this interaction is only for the react grid
                                    continue;
                                }
                                if (spliceOperation.Delete !== undefined && spliceOperation.Delete !== null && spliceOperation.Index !== undefined && spliceOperation.Index !== null) {
                                    var insertCount = (spliceOperation.Insert ? spliceOperation.Insert.length : 0);
                                    var spliceMethodParams = [spliceOperation.Index, spliceOperation.Delete];
                                    // Sync mark indexes with splice operation changes by deleting the records at specified index and inserting default values for the records to be inserted.
                                    var markedIndexesSpliceMethodParams = Array.prototype.slice.call(spliceMethodParams, 0);
                                    for (var k = 0; k < insertCount; k++) {
                                        // Let's add default value, assuming that actual value will come when deserializing the model
                                        markedIndexesSpliceMethodParams.push(false);
                                    }
                                    var markedIndexesValue = $dyn.value(this.markedIndexes);
                                    Array.prototype.splice.apply(markedIndexesValue, markedIndexesSpliceMethodParams);
                                    for (var j = 0; j < insertCount; j++) {
                                        spliceMethodParams.push(this.deserializeModel(spliceOperation.Insert[j], j + spliceOperation.Index, formId));
                                    }
                                    Array.prototype.splice.apply(currentItems, spliceMethodParams);
                                    this.markedIndexes(markedIndexesValue);
                                    this.markedIndexes.valueChanged.raise();
                                }
                                else {
                                    $dyn.logWarning("Unexpected ModelCollection splice operation descriptor format: %o", spliceOperation);
                                }
                            }
                            var firstChangedIndex = 0;
                            var firstOperation = data.SpliceOperations[0];
                            if (firstOperation && firstOperation.Index !== undefined && firstOperation.Index !== null) {
                                firstChangedIndex = firstOperation.Index;
                            }
                            // Fix the model indicies since they changed
                            for (var i = firstChangedIndex, len = currentItems.length; i < len; i++) {
                                currentItems[i].collectionIndex = i;
                            }
                            this.items(currentItems);
                        }
                    }
                }
                else if (data.Items) {
                    this._pendingCollectionChange = true;
                    var results = [];
                    var isListViewDS = this.name.endsWith("_lvds");
                    var isTableDS = this.name.endsWith("_tableds_");
                    for (var i = 0, len = data.Items.length; i < len; i++) {
                        if (this.UseReactGrid && !isListViewDS && !isTableDS && this.name !== "ClientMessageLog") {
                            if (data.Items[i].Item.Properties.MasterTrackingId) {
                                var modelId = this.name + "_" + data.Items[i].Item.Properties.MasterTrackingId;
                                var alreadyExist = serverForm.ModelManager.getModel(modelId, formId) ? true : false;
                                var model = this.deserializeModel(data.Items[i], i, formId);
                                if (!alreadyExist) {
                                    results.push(model);
                                }
                            }
                            else {
                                $dyn.log.reactList && $dyn.log.reactList("Item without master tracking id: " + data.Items[i].Id);
                            }
                        }
                        else {
                            results.push(this.deserializeModel(data.Items[i], i, formId));
                        }
                    }
                    if (this.UseReactGrid && !isListViewDS && !isTableDS) {
                        if (results.length) {
                            if ($dyn.length(this.items) === 0) {
                                this.items(results);
                            }
                            else if (serverForm.ModelManager.loadDirection === $dyn.ui.ScrollDirection.up) {
                                var temp = $dyn.value(this.items);
                                this.items(results.concat(temp));
                            }
                            else {
                                if ($dyn.log.reactList && serverForm.ModelManager.loadDirection === $dyn.ui.ScrollDirection.none) {
                                    $dyn.log.reactList("Unexpected scenario of updating items collection with no load direction");
                                }
                                var temp = $dyn.value(this.items);
                                this.items(temp.concat(results));
                            }
                        }
                    }
                    else {
                        // Subscribers to the items collection are responsible for syncing items.
                        this.items(results);
                    }
                }
                if (data.ActiveRecordIndex !== undefined &&
                    data.ActiveRecordIndex !== null &&
                    (!this.UseReactGrid ||
                        $dyn.value(this.selectedIndex) === -1 ||
                        !this.clientMarking)) {
                    this.selectedIndex(data.ActiveRecordIndex);
                }
                if (data.ActiveRecordModel) {
                    // ActiveRecordModel comes as collection. We expect it to have 0 or 1 elements. Empty array means that ActiveRecordModel removed
                    // This is not needed for the reactGrid because the activeRecord is always on the client
                    if (data.ActiveRecordModel.length && !this.UseReactGrid) {
                        this.activeRecordModel(this.deserializeModel(data.ActiveRecordModel[0], undefined, formId));
                    }
                    else {
                        this.activeRecordModel(null);
                    }
                }
                if (data.IsLastPage !== undefined && data.IsLastPage !== null) {
                    this.hasNextPage(!data.IsLastPage);
                }
                if (data.CurrentPageIndex !== undefined && data.CurrentPageIndex !== null) {
                    this.pageIndex(data.CurrentPageIndex);
                }
                if (data.ClientPageSize !== undefined && data.ClientPageSize !== null) {
                    this.clientPageSize(data.ClientPageSize);
                }
                if (data.CacheSize !== undefined && data.CacheSize !== null) {
                    this.CacheSize(data.CacheSize);
                }
                if (data.DataAbove !== undefined && data.DataAbove !== null) {
                    this.DataAbove(!!data.DataAbove);
                }
                if (data.DataBelow !== undefined && data.DataBelow !== null) {
                    this.DataBelow(!!data.DataBelow);
                }
                if (data.IsDirty !== undefined && data.IsDirty !== null) {
                    this.IsDirty = data.IsDirty;
                }
                if (data.IsCrossCompany !== undefined && data.IsCrossCompany !== null) {
                    this.IsCrossCompany = data.IsCrossCompany;
                }
                if (data.ActiveMasterTrackingId) {
                    if (data.ActiveMasterTrackingId === "0") {
                        data.ActiveMasterTrackingId = "";
                    }
                    this.activeRecord_mastertrackingid(data.ActiveMasterTrackingId);
                    if ($dyn.value(this.internalActiveMasterTrackingId) === "" || !this.clientMarking) {
                        this.internalActiveMasterTrackingId(data.ActiveMasterTrackingId);
                    }
                }
            };
            ModelCollection.prototype.deserializeModel = function (modelItem, modelCollectionIndex, formId) {
                if (!modelItem) {
                    return;
                }
                var modelId = modelItem.Id;
                var model;
                if (modelItem.Id) {
                    model = serverForm.ModelManager.getModel(modelId, formId);
                }
                if (modelItem.Item) {
                    if (!model) {
                        modelId = modelItem.Item.Id;
                        if (this.UseReactGrid && modelItem.Item.Properties.MasterTrackingId) {
                            modelId = this.name + "_" + modelItem.Item.Properties.MasterTrackingId;
                        }
                        model = serverForm.ModelManager.getModel(modelId, formId);
                        if (!model) {
                            model = new serverForm.Model(this);
                        }
                    }
                    if (modelCollectionIndex !== undefined) {
                        model.collectionIndex = modelCollectionIndex;
                    }
                    model.collectionName = this.name;
                    model.deserialize(modelItem.Item, formId);
                    model.parent = this;
                }
                else if (model.CollectionIndex !== undefined) {
                    // TODO: remove this if block since capital CollectionIndex doesn't exit on Model class
                    model.collectionIndex = model.CollectionIndex;
                }
                return model;
            };
            ModelCollection.prototype.generateClientTrackingId = function () {
                this.clientCreatedTrackingId--;
                return this.clientCreatedTrackingId;
            };
            ModelCollection.prototype.executeGroupingActions = function () {
                var e_2, _a;
                if (this.groupingActions && this.groupingActions.length > 0) {
                    try {
                        for (var _b = __values(this.groupingActions), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var action = _c.value;
                            action();
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    this.groupingActions = [];
                }
            };
            ModelCollection.prototype.addGroupingAction = function (action) {
                if (!this.groupingActions) {
                    this.groupingActions = [];
                }
                if (action) {
                    this.groupingActions.push(action);
                    serverForm.UpdateModelManager.pushGroupingChange(this.id);
                }
            };
            return ModelCollection;
        }());
        serverForm.ModelCollection = ModelCollection;
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModelCollection.js.map
